import { createApp } from 'vue'
import App from './Index.vue'

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';

import SlideUpDown from 'vue3-slide-up-down';
import { initializePage } from '../../bootstrap/pageBootstrap.js'

// Initialize page bootstrap
initializePage().then((result) => {
  if (!result.success) {
    console.warn('[Crosssell] Bootstrap failed:', result.error);
  }
});


let app = createApp(App);

app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 3,
  newestOnTop: true,
  position: "top-right",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  closeButton: "button",
  icon: true,
  rtl: false
});

app.use(PrimeVue);
app.component('Dialog', Dialog);
app.component('slide-up-down', SlideUpDown);

app.mount('#app');
